export function uiDate(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = date.toLocaleString("en-US", { month: "short" }); // Add leading zero for single-digit months
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero for single-digit days
    return `${month}-${day}-${year}`;
}

export function uiDateFormat(isoString) {
    const date = new Date(isoString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Add leading zero for single-digit months
    const day = String(date.getDate()).padStart(2, "0"); // Add leading zero for single-digit days
    return `${month}-${day}-${year}`;
}

export function uiTime(isoString) {
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-US", { hour: "numeric", minute: "numeric", hour12: true });
}


export function formatDateTime(isoString) {
    return `${uiDate(isoString)}, ${uiTime(isoString)}`;
}

export function formatDateTimeWithTodayCheck(isoString) {
    const date = new Date(isoString);
    const today = new Date();

    // Check if the date is today
    const isToday =
        date.getFullYear() === today.getFullYear() &&
        date.getMonth() === today.getMonth() &&
        date.getDate() === today.getDate();

    if (isToday) {
        // Return only the time if it's today
        return uiTime(isoString);
    } else {
        // Return date and time if it's not today
        return `${uiDate(isoString)}, ${uiTime(isoString)}`;
    }
}

export const formatDateTimeSeparately = (dateTime) => {
  const date = new Date(dateTime);
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();

  // Format the date as "Thu, 10 Oct"
  const formattedDate = date.toLocaleDateString("en-US", {
    weekday: "short",
    ...(dateYear > currentYear && { year: "numeric" }),
    month: "short",
    day: "2-digit",
  });

  // Format the time as "4:30 pm"
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return { formattedDate, formattedTime };
};

export const formatDateTimeSeparatelyInCDT = (dateTime) => {
  const date = new Date(dateTime);
  const currentYear = new Date().getFullYear();
  const dateYear = date.getFullYear();

  // Format the date as "Thu, 10 Oct" in CDT timezone
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    ...(dateYear > currentYear && { year: "numeric" }),
    month: "short",
    day: "2-digit",
    timeZone: "America/Chicago", // Force CDT timezone
  }).format(date);

  // Format the time as "4:30 pm" in CDT timezone
  const formattedTime = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/Chicago", // Force CDT timezone
  }).format(date);

  return { formattedDate, formattedTime };
};


export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  
    const formattedTime = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // 12-hour format
    });
  
    return `${formattedDate} at ${formattedTime}`;
  };

export const getCurrentTimestamps = () => {
    return new Date().getTime();
}

export const getTimeStamps = (date) => {
    return new Date(date).getTime();
}